function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5637 23.7582C45.9583 26.3401 48.9062 31.1035 48.9062 36.5531C48.9062 44.7524 42.2331 51.398 34 51.398C25.7669 51.398 19.0938 44.7524 19.0938 36.5531C19.0938 31.0365 22.1146 26.2232 26.5989 23.6641",
  stroke: "#0A161F",
  strokeOpacity: 0.2,
  strokeWidth: 3.3125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34 18.28V33.1863",
  stroke: "#0A161F",
  strokeOpacity: 0.2,
  strokeWidth: 3.3125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.125 23.9587C59.125 30.1258 54.1255 35.1253 47.9584 35.1253C41.7912 35.1253 36.7917 30.1258 36.7917 23.9587C36.7917 17.7915 41.7912 12.792 47.9584 12.792C54.1255 12.792 59.125 17.7915 59.125 23.9587Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9584 33.0316C52.9692 33.0316 57.0313 28.9695 57.0313 23.9587C57.0313 18.9478 52.9692 14.8857 47.9584 14.8857C42.9475 14.8857 38.8854 18.9478 38.8854 23.9587C38.8854 28.9695 42.9475 33.0316 47.9584 33.0316Z",
  fill: "#737373"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.9918 19.4219H48.9249L48.7703 25.3936H47.1464L46.9918 19.4219ZM47.9584 28.8814C47.372 28.8814 46.908 28.4368 46.908 27.8697C46.908 27.3027 47.372 26.8581 47.9584 26.8581C48.5448 26.8581 49.0087 27.3027 49.0087 27.8697C49.0087 28.4368 48.5448 28.8814 47.9584 28.8814Z",
  fill: "white"
});

function SvgPowerExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerExclamation);
export default __webpack_public_path__ + "static/media/PowerExclamation.71f3d59f.svg";
export { ForwardRef as ReactComponent };